import { Image } from '@marriott/mi-ui-library';
import {
  CenterContentGrid,
  ButtonRow,
  Card,
  Description,
  Title,
  StyledButton,
  EnrollmentCardContent,
  FloatingCardContent,
} from './EnrollmentCard.styles';
import type { EnrollmentCardProps } from './EnrollmentCard.types';
import clsx from 'clsx';

export function EnrollmentCard({
  className,
  header,
  description,
  children,
  isLoggedInVariant,
  buttons,
  image,
  theme,
}: EnrollmentCardProps) {
  return (
    <Card
      className={clsx(isLoggedInVariant && 'logged-in-variant', className)}
      $isLoggedInVariant={isLoggedInVariant}
      $theme={theme}
      data-testid="homepage-EnrollmentCard"
    >
      {image ? (
        <Image
          altText={image.altText}
          renditions={image.dynamicMedia?.renditions}
          defaultImageURL={image.fileReferenceImage}
          customClass="enrollment-image"
        />
      ) : null}
      <FloatingCardContent>
        <EnrollmentCardContent>
          <Title $isLoggedInVariant={isLoggedInVariant}>{header}</Title>
          <Description $isLoggedInVariant={isLoggedInVariant} $theme={theme}>
            {description}
          </Description>
          {children ? <CenterContentGrid $theme={theme}>{children}</CenterContentGrid> : null}
          <ButtonRow>
            {buttons
              ?.filter(button => button.buttonCopy)
              .map((props, index) => (
                <StyledButton isLink key={index} {...props} />
              ))}
          </ButtonRow>
        </EnrollmentCardContent>
      </FloatingCardContent>
    </Card>
  );
}
